export default "https://assets.egbcdn.net/assets/packs/_/images/crypto-exchange/crypto-5d76363e080f58fe9e6ea28999e18452.png";